import { createContext } from 'react';
import { settings } from 'config';

const AppContext = createContext(settings);

export const ServiceContext = createContext();
export const EditServiceContext = createContext();

export default AppContext;
